import * as yup from "yup";
import { IAddNewBusinessRequest } from "../../../interfaces-and-types";

export const addNewBusinessSchema: yup.SchemaOf<IAddNewBusinessRequest> = yup
  .object({
    merchant_name: yup.string().required("Business Name is required"),
    business_email_address: yup
      .string()
      .email("Please enter a valid email")
      .required("Business Email is required"),
      country:      yup.string()/*.nullable()*/.optional(),
      phone_number: yup.string()/*.nullable()*/.optional(),
      bvn:          yup.string()/*.nullable()*/.optional(),
      nin:          yup.string()/*.nullable()*/.optional(),
    link_account_verification_with_main_account: yup
      .boolean()
      .required("Verification source is required"),
    copy_settings_from_main_account: yup
      .boolean()
      .required("Settings status is required"),
  })
  .required();
